module.exports = __webpack_public_path__ + "img/info.99dd8fed.svg";